import { OnboardItemModal } from './OnboardItemModal'

export default OnboardItemModal;
